import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  Column,
  ErrorTag,
  OutlineButton,
  PrimaryButton,
} from 'components/layout/Auth/AuthForm/styles';

import {
  CONTENT_WIDTH,
  NarrowActions,
  OnboardingIntro,
  OnboardingSubtitle,
  OnboardingTitle,
} from '../styles';

export type ValidacaoStatus = 'validando' | 'ok' | 'erro';

type ConclusaoProps = {
  status: ValidacaoStatus;
  erro: string | null;
  onRetry: () => void;
};

const TEXTOS: Record<ValidacaoStatus, { titulo: string; texto: string }> = {
  validando: {
    titulo: 'Estamos validando seu acesso',
    texto: 'Aguarde só um instante enquanto confirmamos suas informações.',
  },
  ok: {
    titulo: 'Tudo pronto!',
    texto: 'Você já pode acessar o portal Minha Ultragaz',
  },
  erro: {
    titulo: 'Não conseguimos validar seu acesso',
    texto:
      'O link pode ter expirado ou já ter sido utilizado. Gere uma nova validação para concluir seu cadastro.',
  },
};

const Conclusao = ({ status, erro, onRetry }: ConclusaoProps): JSX.Element => {
  const history = useHistory();
  const { titulo, texto } = TEXTOS[status];

  return (
    <Column gap={24} width={CONTENT_WIDTH}>
      <OnboardingIntro>
        <OnboardingTitle>{titulo}</OnboardingTitle>
        <OnboardingSubtitle>{texto}</OnboardingSubtitle>
      </OnboardingIntro>

      {status === 'erro' && !!erro && <ErrorTag role="alert">{erro}</ErrorTag>}

      <NarrowActions>
        {status === 'erro' ? (
          <OutlineButton
            type="button"
            variant="secondary"
            shape="pill"
            fullWidth
            onClick={onRetry}
          >
            Tentar novamente
          </OutlineButton>
        ) : (
          <PrimaryButton
            type="button"
            shape="pill"
            fullWidth
            disabled={status !== 'ok'}
            onClick={() => history.push('/')}
          >
            Ir para o portal Minha Ultragaz
          </PrimaryButton>
        )}
      </NarrowActions>
    </Column>
  );
};

export default Conclusao;
